import { useTranslation } from "react-i18next";
import { KanbanBoardStatus } from "../types";

export const useKanbanColumnLabels = () => {
  const { t } = useTranslation();

  return {
    [KanbanBoardStatus.Live]: t("kanban.live"),
    [KanbanBoardStatus.Draft]: t("kanban.draft"),
    [KanbanBoardStatus.Archived]: t("kanban.archived"),
  };
};
